module.exports = __webpack_public_path__ + "images/6da3e71335e1922c25c84b95c8bab948.png";